export default __webpack_public_path__ + "static/O0085-11a54f08d74dc18f163a584115b3bb98.png";